<template>
  <Modal
    class="occurrences-modal"
    title="Ocorrências"
    :active.sync="active"
    @close="closeModal"
  >
    <FormOccurrence
      class="mb-4"
      :entityId="entityId"
      :saveOccurrenceApi="saveOccurrenceApi"
      @update="getOccurrences"
    />
    <ListOccurrences :occurrences="occurrences" />
  </Modal>
</template>
<script>
import Modal from '../../components/Modal.vue';
import 'quill/dist/quill.snow.css';
import FormOccurrence from '../forms/FormOccurrence.vue';
import ListOccurrences from '../lists/ListOccurrences.vue';

export default {
  name: 'ModalShowAndCreateOccurrences',
  props: ['popupActive', 'entityId', 'saveOccurrenceApi', 'getOccurrencesApi'],
  components: { Modal, FormOccurrence, ListOccurrences },
  watch: {
    entityId(newValue) {
      if (newValue) {
        this.getOccurrences();
      }
    },
    popupActive(newValue) {
      if (newValue) {
        this.openModal();
      }
    },
  },
  data() {
    return {
      occurrences: [],
      active: false,
    };
  },
  methods: {
    openModal() {
      this.active = true;
    },
    closeModal() {
      this.active = false;
      this.$emit('close');
    },
    async getOccurrences() {
      this.occurrences = await this.getOccurrencesApi(this.entityId);
    },
  },
};
</script>
<style lang="scss">
.occurrences-modal .vs-popup {
  width: 80%;
}
</style>
